'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Base interface for informant metric.
 *
 * @export
 */

/**
 * CPU and Memory metrics.
 *
 * @export
 * @extends {InformantMetric}
 */

/**
 * Disk metric.
 * 4 possible path names: log, kafka, gstore, home.
 *
 * @export
 * @extends {InformantMetric}
 */

/**
 * Network Metric.
 *
 * @export
 * @extends {InformantMetric}
 */

/**
 * Service status.
 *
 * @export
 * @extends {InformantMetric}
 */

/**
 *  Service state metric.
 *
 * @export
 * @enum {number}
 */
var ServiceState = /*#__PURE__*/function (ServiceState) {
  ServiceState[ServiceState["Offline"] = 0] = "Offline";
  ServiceState[ServiceState["Warmup"] = 1] = "Warmup";
  ServiceState[ServiceState["Online"] = 2] = "Online";
  return ServiceState;
}({}); // TODO: Support more status in the future.
// StatusUnchanged,
// StatusUnknown,
// Readonly,
// Paused,
// Stopping,
// Down,

exports.ServiceState = ServiceState;
